import { useEffect, useRef } from 'react'

export default function usePolling(callback, interval, enabled) {
  const savedRef = useRef()

  useEffect(() => {
    savedRef.current = callback
  }, [callback])

  useEffect(() => {
    if (!enabled) return
    const handler = () => savedRef.current?.()
    const id = setInterval(handler, interval)
    return () => clearInterval(id)
  }, [interval, enabled])
}
